import React from 'react';

export function ReactPlayground() {
  return <div>React Playground</div>;
}
